import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { commonSubtitleText, commonTitleText } from 'src/modules/utils/constants'

export default (props) => {
  return (
    <USTemplateDefault
      location={props.location}
      lang="en"
      market="us"
      title={commonTitleText.streamLiveTVSports}
      subtitle={commonSubtitleText.onAnyDevice}
      showRSN={true}
      showMiniplayer="collapsed"
    />
  )
}
